import types from './types';

const loadCurrentCustomerConfiguration = () => ({
  type: types.LOAD_CURRENT_CUSTOMER_CONFIGURATION,
});

const loadCurrentCustomerConfigurationSuccess = (customerConfiguration) => ({
  type: types.LOAD_CURRENT_CUSTOMER_CONFIGURATION_SUCCESS,
  payload: {
    customerConfiguration,
  },
});

const loadCurrentCustomerConfigurationSimpleSuccess = (customerConfigurationSimple) => ({
  type: types.LOAD_CURRENT_CUSTOMER_CONFIGURATION_SIMPLE_SUCCESS,
  payload: {
    customerConfigurationSimple,
  },
});

const loadCurrentCustomerLogoSuccess = (logoFile) => ({
  type: types.LOAD_CURRENT_CUSTOMER_LOGO_SUCCESS,
  payload: {
    logoFile,
  },
});

const loadCurrentCustomerDarkLogoSuccess = (darkLogoFile) => ({
  type: types.LOAD_CURRENT_CUSTOMER_DARK_LOGO_SUCCESS,
  payload: {
    darkLogoFile,
  },
});

const clearCustomerConfiguration = () => ({ type: types.CLEAR_CUSTOMER_CONFIGURATION });

export default {
  loadCurrentCustomerConfiguration,
  loadCurrentCustomerConfigurationSuccess,
  loadCurrentCustomerConfigurationSimpleSuccess,
  clearCustomerConfiguration,
  loadCurrentCustomerLogoSuccess,
  loadCurrentCustomerDarkLogoSuccess
};
